import { Injectable } from '@angular/core';

@Injectable()
export class MasterDataProviderService {
  currentUser;
  authResponse;
  profileSelected;
  constructor() {
    this.loadFromSession();
  }
  loadFromSession(){
    /**let authReq=localStorage.getItem('authRequest');
      if(authReq){
        this.authRequest=JSON.parse(authReq);
      } */
      let authResp=sessionStorage.getItem('authResponse');
      if(authResp){
        this.authResponse=JSON.parse(authResp);
      } 
      if (this.authResponse&&this.authResponse.students) {
      this.currentUser = this.authResponse.students[0];
    }
  }
  logout() {
    this.currentUser = null;
    this.authResponse = null;
  }
  isLogedIn() {
    return (this.authResponse && this.authResponse.token);
  }
  getAuthResp(){
    return this.authResponse;
  }
   getCurrentUser(){
    return this.currentUser;
  }
  loadData(authRequest,authResponse) {
    authRequest.authToken=authResponse.token;  
    authRequest.password=''; 
    authRequest.parentAppDeviceId= authResponse.parentAppDeviceId;                
    localStorage.setItem("authRequest", JSON.stringify(authRequest));
    sessionStorage.setItem("authResponse", JSON.stringify(authResponse));  
    this.authResponse = authResponse;//JSON.parse(sessionStorage.getItem("authResponse"));
    if (this.authResponse) {
      this.currentUser = this.authResponse.students[0];
    }
  }
  getStudetList(){
    return this.authResponse.students;
  }
  getProfileName() {
    if(this.profileSelected){
      return this.profileSelected.name;
      }else{
        return null;
      }
  }
  getProfileClass() {
    if(this.profileSelected){
      return this.profileSelected.clss;
      }else{
        return null;
      }
  }
  getProfileQpass() {
    if(this.profileSelected){
      return this.profileSelected.qpassId;
      }else{
        return null;
      }
  }
  getProfileImageUrl() {
    if(this.profileSelected){
      return this.profileSelected.imageUrl;
      }else{
        return null;
      }
  }
  getSchoolName() {
    if(this.authResponse){
      return this.authResponse.schoolName;
      }else{
        return null;
      }
  }

  getAppMessage() {
    return this.authResponse.msg;
  }
  getLogoUrl() {
    if(this.authResponse){
        return this.authResponse.schoolLogo;
    }else{
     return null;
    }
  }

  setSelectedProfile(profile) {
    sessionStorage.setItem("currentUser", JSON.stringify(profile));
    this.profileSelected = profile;
  }
  getSelectedProfile() {
    return this.profileSelected;
  }
  getFromCache(url) {
   return sessionStorage.getItem(url);
  }
  cache(url, data) {
    sessionStorage.setItem(url,data);
  }


}


// WEBPACK FOOTER //
// D:/Laxmi/angular/forms/XpressForms/src/app/master-data-provider.service.ts